import { StatusBadge } from "../../../components/ui";
import { formatPointRewardCost } from "../../../models/pointReward";
import { POINT_RULE_BLOCK_TITLE_STYLE } from "../../PointRules/components/PointRulePreview";

export interface PointRewardPreviewProps {
  title: string | null;
  partnerName: string | null;
  pointsCost: number | null;
  /** null = ilimitado; 0 = agotado. */
  stock: number | null;
  /** URL remota o object URL local del archivo elegido. */
  imageUrl: string | null;
  active: boolean;
}

/**
 * Cómo se ve el premio en la app. Solo presentación: recibe los valores del formulario en
 * vivo y no toca estado ni API.
 */
export const PointRewardPreview = ({
  title,
  partnerName,
  pointsCost,
  stock,
  imageUrl,
  active,
}: PointRewardPreviewProps) => (
  <section className="flex flex-column" style={{ gap: "var(--space-12)" }}>
    <h3 className="m-0" style={POINT_RULE_BLOCK_TITLE_STYLE}>
      Así se ve en la app
    </h3>
    <div
      className="surface-card surface-border border-1 border-round shadow-1 overflow-hidden"
      style={{ opacity: active ? 1 : 0.5 }}
    >
      {imageUrl ? (
        <img
          src={imageUrl}
          alt=""
          style={{ display: "block", width: "100%", aspectRatio: "16 / 9", objectFit: "cover" }}
        />
      ) : (
        <div
          className="surface-100 flex align-items-center justify-content-center"
          style={{ width: "100%", aspectRatio: "16 / 9" }}
        >
          <i className="pi pi-gift text-600" style={{ fontSize: "2rem" }} aria-hidden />
        </div>
      )}
      <div className="flex flex-column p-3" style={{ gap: "var(--space-6)", overflowWrap: "anywhere" }}>
        <div className="font-semibold">
          {title ?? <span className="text-color-secondary">Sin título</span>}
        </div>
        {partnerName && <small className="text-600">{partnerName}</small>}
        <span className="font-bold" style={{ color: "var(--success-default)" }}>
          {pointsCost === null ? "— puntos" : formatPointRewardCost(pointsCost)}
        </span>
        {stock === 0 && (
          <div>
            <StatusBadge label="Agotado" tone="error" />
          </div>
        )}
        {stock !== null && stock > 0 && <small className="text-600">{`Quedan ${stock}`}</small>}
      </div>
    </div>
    {!active && <small className="text-600">Este premio no se muestra en la app.</small>}
  </section>
);
